/**
 * @generated SignedSource<<ff0511238234c13aea35866b9b858cc7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AudioPlayer_audio",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "Attachment",
  "abstractKey": null
};

node.hash = "43f776f68d9881e18b32d1accd6bff6d";

module.exports = node;
